diffToResult